import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'

import { css, cx } from '@portal/styled-system/css'

import { $clientRuntime } from '@/entities/game'
import { isFeatureEnabled } from '@/shared/config'

import { clientRuntimeToggled } from './model'

export type ClientRuntimeToggleProps = {
    className?: string
}

export function ClientRuntimeToggle({ className }: ClientRuntimeToggleProps) {
    const [clientRuntime, toggle] = useUnit([$clientRuntime, clientRuntimeToggled])

    // NOTE: $clientRuntime is restored from localStorage on the client, so the first
    // render must be skipped to match the server-rendered HTML
    const [mounted, setMounted] = useState(false)
    useEffect(() => setMounted(true), [])

    if (!mounted || !isFeatureEnabled('rust-client')) {
        return null
    }

    return (
        <li className={cx(toggleBadge, className)} onClick={() => toggle()} title="Switch client runtime">
            {clientRuntime === 'rust' ? 'Rust' : 'Haxe'}
        </li>
    )
}

const toggleBadge = css({
    color: 'neutral.600',
    border: '[1px dashed {colors.neutral.400}]',
    borderRadius: 'sm',
    fontSize: '[12px]',
    paddingX: '2',
    paddingY: '[3px]',
    marginRight: '1',
    cursor: 'pointer',
    _hover: {
        color: 'neutral.700',
        borderColor: 'neutral.500',
    },
})
